import React from 'react';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, Restore } from '@mui/icons-material';
import { toast } from "react-toastify";
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE, PRIVATE_USER_GESTION_DE_SERVICIOS, PRIVATE_USER_LIST_DELEGATION_SERVICE } from '../../../Constants/PathsConstants';
import { deleteUnionDelegationServiceService } from '../../../../Domain/Services/UnionDelegationService/DeleteUnionDelegationServiceService';
import { getUnionDelegationServiceListService } from '../../../../Domain/Services/UnionDelegationService/GetUnionDelegationServiceListService';
import { patchUnionDelegationServiceService } from '../../../../Domain/Services/UnionDelegationService/PatchUnionDelegationServiceService';
import Loader from 'UI/Application/Components/Loaders/Loader';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, TextField, Grid, Typography, Pagination, DialogTitle, DialogActions, Dialog, DialogContent, Tooltip, IconButton, InputLabel } from '@mui/material';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { ClearIcon } from "@mui/x-date-pickers";
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { GESTOR_DELEGACIONES_SERVICIOS } from 'Shared/Security/Application/Constants/PermissionsConstant';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';

// import NavigationBreadcrumbs from "UI/Application/Components/Menus/generic/NavigationBreadCrumbs";

function TableUnionDelegationServiceView() {
    const { t } = useTranslation();
    const [sendingApiRequest, setSendingApiRequest] = React.useState(false);
    const [offset, setOffset] = React.useState(0);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [unionDelegationService, setUnionDelegationService] = React.useState([]);
    const [loadUnionDelegationService, setLoadUnionDelegationService] = React.useState(true);
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openRestoreModal, setOpenRestoreModal] = React.useState(false);
    const [selectedId, setSelectedId] = React.useState(null);
    const [filterUnionDelegationServiceName, setFilterUnionDelegationServiceName] = React.useState('');
    const [filterDeleted, setFilterDeleted] = React.useState(0);
    const limit = 10;
    const navigate = useNavigate();
    const { checkPermission } = useAuthContext();
    const [hasAdminPermission, setHasAdminPermission] = React.useState(false);
    console.log(hasAdminPermission);
    React.useEffect(() => {

        const admin = checkPermission(GESTOR_DELEGACIONES_SERVICIOS);

        setHasAdminPermission(admin);

        if (!admin) {
            navigate(PRIVATE_USER_LIST_DELEGATION_SERVICE, { replace: true });
        }
    }, [checkPermission, navigate]);

    const handleDelete = (id) => {
        setSelectedId(id);
        setOpenDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            deleteUnionDelegationServiceService(selectedId).then(response => {
                if (response) {
                    setOpenDeleteModal(false);
                    setLoadUnionDelegationService(true);
                    setSelectedId(null);
                    toast.success(t("unionDelegationService.table.modal.delete.done"));
                }
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    const handleRestore = (id) => {
        setSelectedId(id);
        setOpenRestoreModal(true);
    };

    const handleConfirmRestore = () => {
        if (selectedId && !sendingApiRequest) {
            setSendingApiRequest(true);
            const unionDelegationToRestore = unionDelegationService.find(a => a.id === selectedId);
            if (!unionDelegationToRestore) {
                toast.error(t("unionDelegationService.restore.error"));
                setSendingApiRequest(false);
                return;
            }
            patchUnionDelegationServiceService(selectedId, {
                restore: true,
                unionDelegationServiceName: unionDelegationToRestore.unionDelegationServiceName,
            }).then((response) => {
                if (response) {
                    setOpenRestoreModal(false);
                    setLoadUnionDelegationService(true);
                    setSelectedId(null);
                    toast.success(t("unionDelegationService.table.modal.restore.done"));
                }
            }).catch(error => {
                console.error("Error en PATCH:", error);
                toast.error(t("unionDelegationService.restore.error"));
            }).finally(() => {
                setSendingApiRequest(false);
            });
        }
    };

    const handleFilterDeletedChange = (event) => {
        setFilterDeleted(event.target.value);
        setLoadUnionDelegationService(true);
    };

    const handleFilterUnionDelegationServiceChange = (event) => {
        setFilterUnionDelegationServiceName(event.target.value);
        setLoadUnionDelegationService(true);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setOffset((value - 1) * limit);
        setLoadUnionDelegationService(true);
    };



    // const handleOpenModalEdit = (unionDelegationServiceId) => {
    //     console.log("Editando Gremio con ID:", unionDelegationServiceId);
    //     setId(unionDelegationServiceId);
    //     setOpen(true);
    // };

    React.useEffect(() => {
        if (loadUnionDelegationService) {
            getUnionDelegationServiceListService({
                offset: offset,
                limit: limit,
                filterName: filterUnionDelegationServiceName,
                filterDeleted: filterDeleted,
            }).then((response) => {
                if (!response || !response.records) {
                    setUnionDelegationService([]);
                    return;
                }
                setUnionDelegationService(response.records);
                setLastPage(Math.ceil(response.total / limit));
                setLoadUnionDelegationService(false);
            });
        }
    }, [loadUnionDelegationService, offset, limit, filterUnionDelegationServiceName, filterDeleted]);

    return (
        <>
            <Paper
                sx={{
                    margin: 0,
                    padding: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    width: "100%"
                }}
            >
                <Box display="flex" alignItems="center" mb={1} paddingTop={1} paddingLeft={1}>
                    <IconButton size="small" onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="body2" sx={{ ml: 1, cursor: 'pointer' }} onClick={() => navigate(PRIVATE_USER_GESTION_DE_SERVICIOS)}>Volver</Typography>
                </Box>
                {/* <NavigationBreadcrumbs /> */}
                <Typography variant="h4" sx={{ mb: 2, textAlign: "center" }}>
                    {t('unionDelegationService.table.title')}
                </Typography>

                {/* 🔹 Contenedor de filtros */}
                <Box sx={{ p: 1, flex: 1 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <FormControl sx={{ width: '250px' }}>
                                <TextField
                                    label={t('unionDelegationService.table.filter_by_name')}
                                    variant='outlined'
                                    size='small'
                                    value={filterUnionDelegationServiceName}
                                    onChange={handleFilterUnionDelegationServiceChange}
                                    InputProps={{
                                        endAdornment: filterUnionDelegationServiceName && (
                                            <IconButton onClick={() => setFilterUnionDelegationServiceName('')}>
                                                <ClearIcon />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </FormControl>
                        </Grid>


                        <Grid item>
                            <FormControl sx={{ width: '250px' }}>
                                <InputLabel id="filter-deleted-label">
                                    {t('unionDelegationService.table.filter_by_name_2')}
                                </InputLabel>
                                <Select
                                    labelId='filter-deleted-label'
                                    id='filter-deleted'
                                    label={t('unionDelegationService.table.filter_by_name_2')}
                                    variant='outlined'
                                    size='small'
                                    value={filterDeleted}
                                    onChange={handleFilterDeletedChange}
                                >
                                    <MenuItem value={0}>{t('unionDelegationService.filter_by_deleted_not_deleted')}</MenuItem>
                                    <MenuItem value={1}>{t('unionDelegationService.table.filter_by_deleted_deleted')}</MenuItem>
                                    <MenuItem value={2}>{t('unionDelegationService.table.filter_by_deleted_all')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>

                {/* 🔹 Botón para crear un Union */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, mr: 2 }}>
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to={PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE + "/new"}
                        startIcon={<AddIcon />}
                        sx={{
                            backgroundColor: "green",
                            color: "white",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#008f39" }
                        }}
                    >
                        {t('unionDelegationService.form.create')}
                    </Button>
                </Box>



                {/* 🔹 Tabla de Unions */}
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: "100%" }} aria-label="union table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#0492D4' }}>
                                <TableCell align='center' sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('unionDelegationService.table.name')}
                                </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
                                    {t('unionDelegationService.table.actions')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadUnionDelegationService ? (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : unionDelegationService.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2} align="center">
                                        {t('unionDelegationService.table.no_data')}
                                    </TableCell>
                                </TableRow>
                            ) : (
                                //acciones
                                unionDelegationService.map((union) => (
                                    <TableRow key={union.id}>
                                        {/* <TableCell align='center' sx ={{color: 'black', fontWeight: 'bold'}}>{union.name}</TableCell> */}
                                        <TableCell align='center'>{union.name}</TableCell>
                                        <TableCell align='center'>{union.deletedAt === null ? (
                                            <>
                                                <Tooltip title={t('unionDelegationService.table.actions.edit')}>
                                                    <IconButton component={RouterLink} to={PRIVATE_USER_FORM_UNION_DELEGATION_SERVICE + "/" + union.id}>
                                                        <Edit color="metal" />
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip title={t('unionDelegationService.table.actions.delete')}>
                                                    <IconButton onClick={() => { handleDelete(union.id) }}>
                                                        <Delete color="error" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        ) : (
                                            <>
                                                <Tooltip title={t('unionDelegationService.table.modal.restore.title')}>
                                                    <IconButton onClick={() => handleRestore(union.id)}>
                                                        <Restore color="success" />
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            {/* 🔹 Paginación */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Pagination count={lastPage} page={currentPage} onChange={handlePageChange} />
            </Box>
            {/* 🔹 Modal para eliminar gremios */}
            <Dialog open={openDeleteModal} onClose={() => setOpenDeleteModal(false)}>
                <DialogTitle>{t('unionDelegationService.table.modal.delete.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('unionDelegationService.table.modal.delete.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenDeleteModal(false)}>
                        {t('unionDelegationService.table.modal.delete.button.cancel')}
                    </Button>
                    <Button variant="contained" color="error" onClick={handleConfirmDelete}>
                        {t('unionDelegationService.table.modal.delete.button.delete')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* 🔹 Modal para restaurar unniones */}
            <Dialog open={openRestoreModal} onClose={() => setOpenRestoreModal(false)}>
                <DialogTitle>{t('unionDelegationService.table.modal.restore.title')}</DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{t('unionDelegationService.table.modal.restore.phrase')}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={() => setOpenRestoreModal(false)}>
                        {t('unionDelegationService.table.modal.restore.button.cancel')}
                    </Button>
                    <Button variant="contained" color="success" onClick={handleConfirmRestore}>
                        {t('unionDelegationService.table.actions.restore')}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* 🔹 Aquí agregas el Modal de Crear/Editar
            <FormUnionDelegationServiceView
                id={id}
                open={open}
                onClose={() => setOpen(false)}
            /> */}

            {/* 🔹 Loader para evitar dobles peticiones */}
            <DialogLoader open={sendingApiRequest} />
        </>
    );
}

export default TableUnionDelegationServiceView;
